import { ThemeOptions } from '@material-ui/core'
import { DataTheme } from './Enums'

declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    geoColors: {
      topBar: PaletteColor
      contextBar: PaletteColor
      toolBar: PaletteColor
      text: PaletteColor
      headerText: PaletteColor
      error: PaletteColor
    }
    dataThemeIceAge: PaletteColor
    dataThemeClimate: PaletteColor
    dataThemeEnergy: PaletteColor
    dataThemeEnvironment: PaletteColor
  }
  interface PaletteOptions {
    geoColors?: {
      topBar: PaletteColorOptions
      contextBar: PaletteColorOptions
      toolBar: PaletteColorOptions
      text: PaletteColorOptions
      headerText: PaletteColorOptions
      error: PaletteColorOptions
    }
    dataThemeIceAge?: PaletteColorOptions
    dataThemeClimate?: PaletteColorOptions
    dataThemeEnergy?: PaletteColorOptions
    dataThemeEnvironment?: PaletteColorOptions
  }
}

const dataThemeIceAgeMain = '#01579b'
const dataThemeClimateMain = '#33691e'
const dataThemeEnergyMain = '#00838f'
const dataThemeEnvironmentMain = '#ab5600'

const common = {
  common: {
    black: '#000000',
    white: '#ffffff'
  },
  error: {
    main: '#fe2020'
  },
  geoColors: {
    topBar: {
      main: '#403f44'
    },
    contextBar: {
      main: '#ebebeb',
      dark: '#cccccc'
    },
    toolBar: {
      main: '#666666',
      light: '#cccccc',
      dark: '#333333'
    },
    text: {
      main: '#000000',
      light: '#555555'
    },
    headerText: {
      main: '#ffffff'
    },
    error: {
      main: '#e29fa2'
    }
  },
  dataThemeIceAge: {
    main: dataThemeIceAgeMain
  },
  dataThemeClimate: {
    main: dataThemeClimateMain
  },
  dataThemeEnergy: {
    main: dataThemeEnergyMain
  },
  dataThemeEnvironment: {
    main: dataThemeEnvironmentMain
  }
}

export const defaultTheme: ThemeOptions = {
  palette: {
    ...common,
    primary: {
      main: '#70533f',
      light: '#AB8C76'
    },
    secondary: {
      main: '#fff9e7'
    }
  }
}

export const iceAgeTheme: ThemeOptions = {
  palette: {
    ...common,
    primary: {
      main: dataThemeIceAgeMain,
      light: '#79B4E3'
    },
    secondary: {
      main: '#cfd8dc'
    }
  }
}

export const climateTheme: ThemeOptions = {
  palette: {
    ...common,
    primary: {
      main: dataThemeClimateMain,
      light: '#7AB463'
    },
    secondary: {
      main: '#c8e6c9'
    }
  }
}

export const energyTheme: ThemeOptions = {
  palette: {
    ...common,
    primary: {
      main: dataThemeEnergyMain,
      light: '#6AC0C8'
    },
    secondary: {
      main: '#e0f7fa'
    }
  }
}

export const environmentTheme: ThemeOptions = {
  palette: {
    ...common,
    primary: {
      main: dataThemeEnvironmentMain,
      light: '#a98274'
    },
    secondary: {
      main: '#ffe0b2'
    }
  }
}

export const getThemeOptionsByDataTheme = (dataTheme: DataTheme): ThemeOptions => {
  switch (dataTheme) {
    case DataTheme.ICE_AGE:
      return iceAgeTheme
    case DataTheme.CLIMATE:
      return climateTheme
    case DataTheme.ENERGY:
      return energyTheme
    case DataTheme.ENVIRONMENT:
      return environmentTheme
    case DataTheme.NONE:
      return defaultTheme
  }
}
